var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.66667V17.5M10 6.66667C9.69856 5.4245 9.17954 4.36251 8.51061 3.61926C7.84169 2.87601 7.0539 2.48595 6.25 2.49996C5.69747 2.49996 5.16756 2.71945 4.77686 3.11015C4.38616 3.50085 4.16667 4.03076 4.16667 4.58329C4.16667 5.13582 4.38616 5.66573 4.77686 6.05643C5.16756 6.44713 5.69747 6.66662 6.25 6.66662M10 6.66667C10.3014 5.4245 10.8205 4.36251 11.4894 3.61926C12.1583 2.87601 12.9461 2.48595 13.75 2.49996C14.3025 2.49996 14.8324 2.71945 15.2231 3.11015C15.6138 3.50085 15.8333 4.03076 15.8333 4.58329C15.8333 5.13582 15.6138 5.66573 15.2231 6.05643C14.8324 6.44713 14.3025 6.66662 13.75 6.66662M15.8333 10V15.8333C15.8333 16.2754 15.6577 16.6993 15.3452 17.0118C15.0326 17.3244 14.6087 17.5 14.1667 17.5H5.83333C5.39131 17.5 4.96738 17.3244 4.65482 17.0118C4.34226 16.6993 4.16667 16.2754 4.16667 15.8333V10M3.33333 6.66667H16.6667C17.1269 6.66667 17.5 7.03976 17.5 7.5V9.16667C17.5 9.6269 17.1269 10 16.6667 10H3.33333C2.8731 10 2.5 9.6269 2.5 9.16667V7.5C2.5 7.03976 2.8731 6.66667 3.33333 6.66667Z",
    stroke: "#6B6E7B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/Gift.ba8099247e3018a703d2841c6c70592a.svg";
export { ForwardRef as ReactComponent };